import React, { useEffect, useState } from 'react';
import * as classes from './StickyHeader.module.scss';
import { useScrollPosition } from '../../../utils/scrollUtils';
import cn from 'classnames';
import ModernHeader from '../../Templates/ModernTemplate/Components/Header/Header';
import { PagesList } from '../../../enums/PagesList';
import { TemplatesList } from '../../../enums/TemplatesList';
import Header from '../../Templates/DefaultTemplate/Components/Header/Header';

const StickyHeader = ({ pageId, logoText, template }: { pageId?: PagesList; logoText: string; template: TemplatesList }) => {
  const [scroll, setScroll] = useState(0);
  const [prevScroll, setPrevScroll] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const HEADER_HEIGHT = 100;

  const scrollHandler = (prevValue: number, value: number) => {
    setScroll(value);
    setPrevScroll(prevValue);
  };

  useScrollPosition(scrollHandler);

  useEffect(() => {
    if (scroll >= HEADER_HEIGHT) {
      setIsSticky(true);
      return;
    }
    setIsSticky(false);
  }, [scroll]);

  if (TemplatesList.MODERN === template) {
    return (
      <div className={cn(classes.wrapper, prevScroll <= scroll && classes.absolute, prevScroll > scroll && classes.visible)}>
        <ModernHeader pageId={pageId} logoText={logoText} isSticky={isSticky} />
      </div>
    );
  }

  return (
    <div className={classes.spacer}>
      <div
        className={cn(classes.wrapper, prevScroll <= scroll && classes.relative, prevScroll > scroll && classes.visible, classes.whiteBg)}
      >
        <Header logoText={logoText} />
      </div>
    </div>
  );
};

export default StickyHeader;
